var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icons/ green / menu") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons/-green-/-menu",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "menu-(3)",
    transform: "translate(24.000000, 24.500000) scale(-1, 1) translate(-24.000000, -24.500000) translate(12.000000, 18.000000)",
    fill: "#02339c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.749922078,1.51499221 L23.2481455,1.51499221 C23.6621299,1.51499221 23.9980675,1.17899221 23.9980675,0.76507013 C23.9980675,0.351085714 23.6620675,0.0151480519 23.2481455,0.0151480519 L0.749922078,0.0151480519 C0.335937662,0.0151480519 0,0.351148052 0,0.76507013 C0,1.17899221 0.336,1.51499221 0.749922078,1.51499221 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2481455,5.26472727 L0.749922078,5.26472727 C0.335937662,5.26472727 0,5.60072727 0,6.01464935 C0,6.42857143 0.336,6.76457143 0.749922078,6.76457143 L23.2481455,6.76457143 C23.6621299,6.76457143 23.9980675,6.42857143 23.9980675,6.01464935 C23.9980675,5.60072727 23.6621299,5.26472727 23.2481455,5.26472727 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2481455,10.5143065 L8.24932987,10.5143065 C7.83534545,10.5143065 7.49940779,10.8503065 7.49940779,11.2642286 C7.49940779,11.678213 7.83540779,12.0141506 8.24932987,12.0141506 L23.2481455,12.0141506 C23.6621299,12.0141506 23.9980675,11.6781506 23.9980675,11.2642286 C23.9980675,10.8502442 23.6621299,10.5143065 23.2481455,10.5143065 Z",
    id: "Path"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.047085e1f22166e374d56eb055ee8ac4.svg";
export { ForwardRef as ReactComponent };